// src/api/axios.js
import axios from 'axios';
import { toast } from 'react-toastify';
import useAuthStore from '../store/authStore';

let isRefreshing = false;
let refreshSubscribers = [];

function onRefreshed(token) {
  refreshSubscribers.forEach(callback => callback(token));
  refreshSubscribers = [];
}

const axiosInstance = axios.create({
  baseURL: 'https://nfcadmin.mhcockpit.com',
  // Removed 'Content-Type' from here — let individual requests set it
});

axiosInstance.interceptors.request.use(
  async (config) => {
    const { access } = useAuthStore.getState();
    if (access) {
      config.headers = config.headers || {};
      config.headers['Authorization'] = `Bearer ${access}`;
    }

    // Only set Content-Type: application/json if it's a plain object and not FormData
    if (
      config.data &&
      !(config.data instanceof FormData) &&
      !config.headers['Content-Type']
    ) {
      config.headers['Content-Type'] = 'application/json';
    }

    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    const { access, refresh } = useAuthStore.getState();

    if (error.response?.status === 401 && !originalRequest._retry && refresh) {
      if (isRefreshing) {
        return new Promise((resolve) => {
          refreshSubscribers.push((token) => {
            originalRequest.headers['Authorization'] = `Bearer ${token}`;
            resolve(axiosInstance(originalRequest));
          });
        });
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        // const { data } = await axiosInstance.post('/api/token/refresh/', {
        //   refresh,
        // });
        const { data } = await axios.post(
          'https://nfcadmin.mhcockpit.com/api/token/refresh/',
          { refresh }
        );
        // useAuthStore.setState({ access: data.access, refresh: data.refresh });
        useAuthStore.setState({ access: data.access });
        onRefreshed(data.access);
        isRefreshing = false;
        originalRequest.headers['Authorization'] = `Bearer ${data.access}`;
        return axiosInstance(originalRequest);
      } 
      // catch (err) {
      //   isRefreshing = false;
      //   toast.error('Session expired. Please log in again.');
      //   // Redirect or handle logout here
      // }
      catch (err) {
  isRefreshing = false;
  useAuthStore.getState().logout();
  toast.error('Session expired. Please log in again.');
  window.location.href = '/';
}
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
